// extracted by mini-css-extract-plugin
module.exports = {"group":"driNOWXoUX9pWHJacN1OS"};